import { Field } from 'redux-form';
import SearchFormFieldRenderer from './SearchFormFieldRender';

/*
$TSFixMe: Previously in d.ts file

import { SearchType } from '@mews-commander/enums';
import { SearchResult } from '@mews-commander/types';

interface SearchFormFieldProps {
    name: string;
    label?: React.ReactNode;
    except?: string[];
    scope: string;
    searchScope: string;
    searchType: SearchType;
    preselectedResultId?: string | null;
    newEntity?: boolean;
    optionalSearchParams?: {
        chainId?: string | null;
    };
    createNewEntity?: (searchResult: SearchResult) => void;
}

declare const SearchFormField: React.FC<SearchFormFieldProps>;

export default SearchFormField;
*/

const parseResultId = (result: $TSFixMe) => (result ? result.id : null);

const SearchFormField = ({ searchType, preselectedResultId, ...other }: $TSFixMe) => (
    <Field
        component={SearchFormFieldRenderer}
        searchTypes={[searchType]}
        preselectedResult={{ id: preselectedResultId, searchType }}
        {...other}
        parse={parseResultId}
    />
);

export default SearchFormField;
